import { render, staticRenderFns } from "./withdrawals-supplier-module.vue?vue&type=template&id=c93625b0&scoped=true&"
import script from "./withdrawals-supplier-module.vue?vue&type=script&lang=js&"
export * from "./withdrawals-supplier-module.vue?vue&type=script&lang=js&"
import style0 from "./withdrawals-supplier-module.vue?vue&type=style&index=0&id=c93625b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93625b0",
  null
  
)

export default component.exports